import SmokeTests from "./SmokeTests";

export default SmokeTests;
